module.exports = __webpack_public_path__ + "static/media/myimage.58248b3e.jpg";